<template>
    <div style="box-sizing: border-box;padding: 20px 0;">
        <div class="tickets">
            <div class="tks">
                <div class="ttitle">
                    基础信息
                </div>
                <div class="signInfo">
                    <div class="formitem flx alc">
                        <div class="finame">
                            <span style="color: #FF4949;">*</span>
                            <span>姓名</span>
                        </div>
                        <div class="ips">
                            <div style="width: 500px;">
                                <el-input placeholder="请输入姓名" v-model="member.name">
                                </el-input>
                            </div>
                        </div>
                    </div>

                    <div class="formitem flx alc">
                        <div class="finame">
                            <span style="color: #FF4949;">*</span>
                            <span>手机号</span>
                        </div>
                        <div class="ips">
                            <div style="width: 500px;">
                                <el-input placeholder="请输入手机号" v-model="member.tel">
                                </el-input>
                            </div>
                        </div>
                    </div>

                    <div class="formitem flx alc">
                        <div class="finame">
                            <span style="color: #FF4949;">*</span>
                            <span>验证码</span>
                        </div>
                        <div class="ips">
                            <div style="width: 500px;">
                                <!-- <el-input placeholder="请输入手机验证码" v-model="code" >
                                </el-input> -->
                                <el-input v-model="code" placeholder="请输入验证码" style="width: 500px;">
                                    <!-- input插槽，右侧按钮 -->
                                    <template slot="append">
                                        <el-button :disabled="isCountDown" @click="getCode" size="small">
                                            {{ isCountDown ? `${count}s后重新获取` : '获取验证码' }}
                                        </el-button>
                                    </template>
                                </el-input>
                            </div>
                        </div>
                    </div>

                    <div class="formitem flx alc">
                        <div class="finame">
                            <span style="color: #FF4949;">*</span>
                            <span>邮箱</span>
                        </div>
                        <div class="ips">
                            <div style="width: 500px;">
                                <el-input placeholder="请输入邮箱" v-model="member.email">
                                </el-input>
                            </div>
                        </div>
                    </div>

                    <div class="ttitle" style="margin-top: 90px;">
                        详细信息
                    </div>
                    <div class="formitem flx alc">
                        <div class="finame">
                            <span style="color: #FF4949;">*</span>
                            <span>公司名称</span>
                        </div>
                        <div class="ips">
                            <div style="width: 500px;">
                                <el-input placeholder="请输入公司名称" v-model="member.company_name">
                                </el-input>
                            </div>
                        </div>
                    </div>
                    <div class="formitem flx alc">
                        <div class="finame">
                            <span style="color: #FF4949;">*</span>
                            <span>岗位职务</span>
                        </div>
                        <div class="ips">
                            <div style="width: 500px;">
                                <el-select v-model="member.position" placeholder="请选择岗位职务">
                                    <el-option v-for="item in col1" :key="item.id" :label="item.name"
                                        :value="item.id"></el-option>
                                </el-select>
                            </div>

                        </div>
                    </div>
                    <div class="formitem flx alc">
                        <div class="finame">
                            <span style="color: #FF4949;">*</span>
                            <span>行业类型</span>
                        </div>
                        <div class="ips">
                            <div style="width: 500px;">
                                <el-select v-model="member.industry_type" placeholder="请选择行业类型">
                                    <el-option v-for="item in col2" :key="item.id" :label="item.name"
                                        :value="item.id"></el-option>
                                </el-select>
                            </div>
                        </div>
                    </div>

                    <div class="formitem flx alc">
                        <div class="finame">
                            <span style="color: #FF4949;">*</span>
                            <span>所在地区</span>
                        </div>
                        <div class="ips">
                            <el-cascader style="width: 500px;" v-model="areaValue" :options="areaList"
                                :props="areaProps" :placeholder="areaValue.length > 0?fullName : '请选择省/市/区'" clearable
                                @change="handleAreaChange"></el-cascader>
                        </div>
                    </div>
                    <!-- <div class="formitem flx">
                        <div class="finame">
                            <span style="color: #FF4949;">*</span>
                            <span>填写需求</span>
                        </div>
                        <div class="ips">
                            <div style="width: 500px;">
                                <el-input :rows="6" maxlength="2000" :show-word-limit="true" type="textarea" resize="none"
                                    count placeholder="请输入职位描述" v-model="member.demand">
                                </el-input>
                            </div>
                        </div>
                    </div> -->

                    <!-- <div class="formitem flx alc">
                        <div class="finame">
                            <span style="color: #FF4949;">*</span>
                            <span>身份验证</span>
                        </div>
                        <div class="ips">
                            <el-upload class="upload-demo" action="https://hrxsl.com/api/Common/oss_upload"
                                :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload"
                                :headers="uploadHeaders" :show-file-list="false">
                                <div class="upimage">
                                    <img v-if="!member.id_img" :src="$Localimg('gup.png')" alt="" />
                                    <img v-else :src="$img(member.id_img)" alt="" />
                                </div>
                            </el-upload>
                        </div>
                    </div> -->

                    <!-- <div class="formitem flx alc">
                        <div class="finame">
                            <span style="color: #FF4949;">*</span>
                            <span>推荐人</span>
                        </div>
                        <div class="ips">
                            <div style="width: 500px;">
                                <el-input placeholder="请输入推荐人" v-model="member.promoter">
                                </el-input>
                            </div>
                        </div>
                    </div> -->

                </div>
            </div>

            <div class="flx jsc">
                <el-button class="signup" type="primary" @click="setSignInfo">修改信息</el-button>
            </div>

        </div>
    </div>
</template>

<script>
    import {
        signpage,
        getRIndex,
        getSignInfo,
        signAc,
        setSignInfo,
        sendCode
    } from "@/api/index.js"
    import areaList from '@/assets/area.json'
    export default {
        data() {
            return {
                uploadHeaders: {
                    token: localStorage.getItem('token'),
                    source: "pc"
                },
                id: "",
                channel_id: "",
                num: 1,
                ticket_id: "",
                info: {},
                col1: [],
                col2: [],
                member: {
                    name: "",
                    tel: '',
                    email: "",
                    company_name: "",
                    industry_type: "",
                    industry_name: "",
                    position: "",
                    position_name: "",
                    sex_name: "",
                    address: "",
                    id_img: "",
                    qq: "",
                    wx_number: "",
                    promoter: "",
                    demand: "",
                    ed: "",
                    sex: ""
                },
                areaList: areaList,
                areaProps: {
                    value: 'label',
                    label: 'label',
                    children: 'children'
                },
                accate: [],
                areaValue: [],
                radio: '1',
                code: '',
                isCountDown: false,
                count: 60,
                timer: null,
                fullName: ""
            }
        },
        created() {
            let that = this
            let data = {}
            data.activity_id = that.$route.query.id
            data.num = 1
            data.spec_id = that.$route.query.spec_id
            // signpage(data).then((res) => {
            //     console.log('page', res)
            //     if (res.code == 1) {
            //         that.info = res.data
            //         that.$nextTick(() => {
            //             window.scrollTo(0, 0)
            //         })
            //     }
            // })
        },
        mounted() {
            let that = this
            getRIndex().then((res) => {
                if (res.code == 1) {
                    that.col1 = res.data.where_category[2].list
                    that.col2 = res.data.where_category[5].list
                }
            })
        },
        beforeDestroy() {
            if (this.timer) {
                clearInterval(this.timer)
            }
        },
        methods: {
            getCode() {
                let that = this
                // 手机号简单校验，按需修改正则
                if (!/^1[3-9]\d{9}$/.test(that.member.tel)) {
                    that.$message.warning('请输入正确手机号')
                    return
                }
                let data = {}
                data.tel = that.member.tel
                data.type = 2
                sendCode(data).then((res) => {
                    console.log(res)
                    if (res.code == 1) {
                        // 开始倒计时
                        that.startTimer()
                        that.$message.success('验证码已发送')
                    } else {
                        that.$message.error(res.msg)
                    }
                })
            },
            startTimer() {
                this.isCountDown = true
                this.count = 60
                this.timer = setInterval(() => {
                    this.count--
                    if (this.count <= 0) {
                        clearInterval(this.timer)
                        this.isCountDown = false
                    }
                }, 1000)
            },
            setSignInfo() {
                let that = this
                let data = {}
                // console.log(111,that.member)
                data.name = that.member.name
                data.tel = that.member.tel
                data.yzm = that.code
                data.email = that.member.email
                data.company_name = that.member.company_name
                data.industry_type = that.member.industry_type
                data.position = that.member.position
                data.address = that.areaValue[0] + '_' + that.areaValue[1]
                data.promoter = that.promoter
                setSignInfo(data).then((res) => {
                    if (res.code == 1) {
                        that.$message.success(res.msg)
                        window.location.href = "http://hrxsl.com"
                    } else {
                        that.$message.error(res.msg)
                    }
                })
            },
            signupAc() {
                console.log(this.member)
                let that = this
                let data = {}
                let t = []
                t.push(that.member)
                data.activity_id = that.$route.query.id
                data.num = 1
                data.spec_id = that.$route.query.spec_id
                data.channel_id = that.$route.query.channel_id || ''
                data.activityRegistration = JSON.stringify(t)
                console.log(data)
                signAc(data).then((res) => {
                    if (res.code == 1) {
                        that.$message.success(res.msg)
                        setTimeout(() => {
                            that.$router.push('/punSuccess')
                        }, 2000)
                    } else {
                        that.$message.error(res.msg)
                    }
                })
            },
            handleAvatarSuccess(e) {
                let that = this
                if (e.code == 1) {
                    that.member.id_img = e.data.url
                } else {
                    this.$message.error(e.data.msg)
                }
            },
            beforeAvatarUpload(file) {
                // 1. 允许的图片格式
                const allowType = ['image/png', 'image/jpg', 'image/jpeg']
                // 2. 最大8MB
                const maxSize = 8 * 1024 * 1024

                // 校验格式
                if (!allowType.includes(file.type)) {
                    this.$message.error('仅支持 png、jpg、jpeg 格式图片！')
                    return false
                }

                // 校验大小
                if (file.size > maxSize) {
                    this.$message.error('图片不能大于8MB！')
                    return false
                }

                // 校验通过，允许上传
                return true
            },
            handleAreaChange(e) {
                console.log(e)
                console.log(this.areaValue)
                this.member.address = this.areaValue[0] + "_" + this.areaValue[1]
            }
        }
    }
</script>

<style scoped>
    .tks {
        width: 800px;
        margin: 0 auto;
    }

    .signInfo {
        margin-top: 30px;
    }

    .upimage {
        width: 516px;
        height: 252px;
    }

    .ticketpart {
        border-right: 1px solid #f2f2f2;
    }

    .ticketTable {
        border: 1px solid #F2F2F2;
        margin-top: 31px;
    }

    .signup {
        width: 303px;
        height: 48px;
        margin: 0 auto;
    }

    .ticketDe {
        height: 85px;
        text-align: center;
        font-size: 14px;
        color: #141933;
        line-height: 85px;
    }

    .ticketTitle {
        height: 32px;
        background: #F2F2F2;
        line-height: 32px;
        font-size: 14px;
        color: #666666;
        text-align: center;
    }

    .ttitle {
        text-align: left;
        font-weight: 600;
        font-size: 18px;
        color: #000;
        margin-bottom: 30px;
    }

    .tickets {
        width: 1460px;
        background: #fff;
        box-sizing: border-box;
        padding: 40px 30px;
        margin: 0 auto;
        border-radius: 10px;
    }

    .piaoCon {
        width: 1460px;
        margin: 0 auto;
    }

    .ipll {
        flex: 1;
    }

    .el-cascader .el-input .el-input__inner {
        width: 500px !important;
    }

    .el-select {
        width: 100% !important;
    }

    textarea {
        resize: none !important;
    }

    .bot .el-button {
        width: 209px !important;
        height: 46px !important;
    }

    .rules {
        margin-top: 24px;
    }

    .inner {
        width: 100%;
        height: 100%;
        background: #007AFF;
    }

    .rule {
        font-weight: 500;
        font-size: 12px;
        color: #333333;
    }

    .squ {
        width: 14px;
        height: 14px;
        border-radius: 1px;
        border: 1px solid #D9D9D9;
        margin-right: 8px;
        box-sizing: border-box;
        padding: 2px;
    }

    .formitem {
        margin-bottom: 30px;
        justify-content: center;
    }

    .tis .tiitem {
        font-size: 12px;
        color: #838383;
        text-align: left;
        line-height: 24px;
        margin-left: 20px;
    }

    .finame {
        margin-right: 20px;
        font-size: 14px;
        color: #48576A;
        text-align: right;
    }

    .ips .inps {
        width: 500px;
        height: 46px;
    }

    .upimage img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    .formTitle {
        margin-bottom: 31px;
    }

    .ftname {
        font-weight: 500;
        font-size: 18px;
    }

    .bshu {
        width: 3px;
        height: 16px;
        background: #007AFF;
        margin-right: 12px;
    }

    .forms {
        width: 1460px;
        background-color: #fff !important;
        margin: 0 auto;
        box-sizing: border-box;
        padding: 64px 40px;
    }
</style>